import { getStorage, ref, uploadBytesResumable } from 'firebase/storage';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';

export async function uploadImagesAndSaveRecords(formData, images, facility) {
  const db = getFirestore();
  const storage = getStorage();
  const imageCollectionRef = collection(db, 'images');

  try {
    const uploadPromises = images.map((image) => {
      const uniqueFileName = `image-${uuidv4()}-${Date.now()}`;
      const storagePath = `images/${uniqueFileName}`;
      const storageRef = ref(storage, storagePath);
      const metadata = { uploaded: Date.now(), facility: facility };
      const uploadTask = uploadBytesResumable(storageRef, image, metadata);

      return new Promise((resolve, reject) => {
        uploadTask.on(
          'state_changed',
          (snapshot) => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
          },
          (error) => {
            console.log(error);
            reject(error);
          },
          () => {
            resolve(storagePath);
            console.log('Success');
          },
        );
      });
    });

    const imagePaths = await Promise.all(uploadPromises);

    // After all images have been uploaded, save the form data along with image storage paths to Firestore
    const recordPromises = imagePaths.map((path) => {
      return addDoc(imageCollectionRef, {
        ...formData,
        imagePath: path,
        uploaded: Date.now(),
        facility: facility,
      });
    });

    await Promise.all(recordPromises);
    console.log('All data saved successfully');
  } catch (error) {
    console.error('Error saving data: ', error);
  }
}
